import React from "react";
import { LinkComponentProjectDialogInitialState, PageNewState } from ".";

export const LinkComponentProjectDialogContext = React.createContext({
  pageState: LinkComponentProjectDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
